// extracted by mini-css-extract-plugin
module.exports = {"container":"TimeInput__container___do6DQ","colon":"TimeInput__colon___1a97Q","input":"TimeInput__input___3oBag","label":"TimeInput__label___3man0"};